import React from "react";
import { LandingPageLayout } from "../shared/layout";
import { Link } from "react-router-dom";

export function LandingPageScreen() {
  return (
    <LandingPageLayout>
      <div className="flex flex-col min-h-[100dvh]">
        <main className="flex-1 flex flex-col items-center justify-center px-4 md:px-6 space-y-6">
          <div className="max-w-3xl text-center space-y-4">
            <h1 className="text-4xl font-bold tracking-tighter sm:text-5xl md:text-6xl">
              NewTurk PORTAL
            </h1>
            <p className="text-muted-foreground md:text-xl">
              Influencer'lar ve içerik üreticileri için
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                className="inline-flex h-10 items-center justify-center rounded-md bg-primary px-6 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
                href="#"
              >
                İletişim
              </Link>
            </div>
          </div>
        </main>
      </div>
    </LandingPageLayout>
  );
}
